import {Component, OnInit} from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserService} from '../../../services/user.service';
import {NavService} from '../../../services/nav.service';
import {ActivatedRoute} from '@angular/router';
import {NapiService} from '../../../services/napi.service';

@Component({
  selector: 'app-call-details-page',
  templateUrl: './call-details.page.html',
  styleUrls: ['./call-details.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
  ]
})

export class CallDetailsPage implements OnInit {
  callId = null;
  data = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    public sanitizer: DomSanitizer,
    public userService: UserService,
    private napiService: NapiService,
    private nav: NavService,
  ) {
  }

  ngOnInit() {
    this.callId = parseInt(this.activatedRoute.snapshot.paramMap.get('callId'), 10) || 0;
    this.napiService.get('aicoach/call-details/' + this.callId).then((res) => {
      this.data = res;
    });
  }

  closeRecord() {
    this.nav.back();
  }
}
